import { CardProsCons } from './card-pros-cons';

export interface CardDetailsProps {
  tagline?: string;
  prosBullets?: string[];
  consBullets?: string[];
  className?: string;
}

export function CardDetails({ tagline, prosBullets, consBullets, className }: CardDetailsProps) {
  const hasProsCons = Boolean(prosBullets?.length && consBullets?.length);

  if (!tagline && !hasProsCons) return null;

  return (
    <div className={className}>
      {tagline ? (
        <div className="flex flex-col gap-2.5 border-b border-border pb-6">
          <span className="typography-text-bold">Key facts</span>
          <p className="typography-text m-0">{tagline}</p>
        </div>
      ) : null}
      {hasProsCons ? <CardProsCons consBullets={consBullets} prosBullets={prosBullets} /> : null}
    </div>
  );
}
